// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bruteforcesettings-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-C1azEbgd_mjs":"3821430c6f786eb29b60","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CDU2njOJ_mjs":"c6182d23f7230cac1a0c"}[chunkId] + "";
};